import styled from 'styled-components';

export const ImageTextWrapper = styled.div`
    display: flex;
    gap: 8px;
`;

export const ImageWrapper = styled.div`
    position: relative;
    width: 48px;
    min-width: 48px;
    height: 48px;
    background: #f5f5f5;
    border-radius: 50%;
`;

export const CarServicesHeading = styled.div<{ isLandingPage?: boolean }>`
    color: #121212;
    font-family: 'Euclid Circular B';
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 32px;
    letter-spacing: -0.1px;
    align-self: stretch;
`;

export const CarServicesSubText = styled.div`
    color: #4b4b4b;
    font-family: 'Euclid Circular B';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    align-self: stretch;
`;

export const HeadingsWrapper = styled.div`
    display: flex;
    padding: 0 20px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
    margin-bottom: 16px;
`;
